import React from "react";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { ExternalLink } from "lucide-react";

interface SectionHeaderWrapperProps {
  children: React.ReactNode;
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  docsUrl?: string;
  buttons?: JSX.Element;
}

export function SectionHeaderWrapper({
  children,
  title,
  subtitle,
  docsUrl,
  buttons,
}: SectionHeaderWrapperProps) {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-y-3">
        <div className="flex flex-row items-center justify-between gap-x-5">
          <Text variant="h3">{title}</Text>

          {docsUrl && (
            <Button
              variant={ButtonVariant.TextBlue}
              size="sm"
              onClick={() => window.open(docsUrl, "_blank")}
              rightIcon={<ExternalLink size={12} />}
            >
              Learn more in docs
            </Button>
          )}
        </div>

        {(subtitle || buttons) && (
          <div className="flex flex-row items-start justify-between gap-x-5">
            <Text>{subtitle}</Text>
            {buttons}
          </div>
        )}
      </div>
      <div className="py-5">{children}</div>
    </div>
  );
}
